import React, {Component} from 'react';
import {Container, Row, Col, Card, CardBody, CardFooter, Button, Input, InputGroup, FormText} from 'reactstrap';
import { TextMask, InputAdapter } from 'react-text-mask-hoc';
import {ajaxWrapperPost} from "../../../utils/deviceAPI";
import NotificationHOC from "../../../components/Notifications/NotificationHOC"
import { AnimatedDivSlide, AnimatedDivOpacity } from '../../../../src/animations/index';
import posed from 'react-pose';
let RegistrationInProgress = posed.div({
    visibleOpacityuserFormSubmitAction: {
        opacity:1,
        transition: {
            ease:[0.530, 0.035, 0.070, 1.290],
            duration: 500,
        }
    },
    hiddenOpacityuserFormSubmitAction: {
        opacity: 0,
        transition: {
            ease:[0.530, 0.035, 0.070, 1.290],
            duration: 500,
        }
    }
});

let RegistrationMessage = posed.div({
    visibleRegistrationMessage: {
        opacity:1,
        transition: {
            ease:[0.530, 0.035, 0.070, 1.290],
            duration: 500,
        }
    },
    hiddenRegistrationMessage: {
        opacity: 0,
        transition: {
            ease:[0.530, 0.035, 0.070, 1.290],
            duration: 500,
        }
    }
});

class Register extends Component {
    constructor(props) {
        super(props);
        this.state = {
            firstName: "",
            userFirstNameValid: false,
            userFirstNameMessage: "",
            lastName: "",
            userLastNameValid: false,
            userLastNameMessage: "",
            email: props.match.params.email === "none" ? "" : props.match.params.email,
            userEmailValid: props.match.params.email !== "none",
            userEmailMessage: "",
            password:"",
            userPasswordValid: false,
            userPasswordMessage: "",
            passwordR:"",
            userPasswordRValid: false,
            userPasswordRMessage: "",
            referral: props.match.params.referral === "none" ? "" : props.match.params.referral,
            userReferralValid: props.match.params.referral !== "none",
            userReferralMessage: "",
            telephone:"",
            userTelephoneValid: false,
            userTelephoneMessage: "",
            userFormValid: false,
            registrationPage: true,
            userFormSubmitAction: false,
            userFormSubmitActionButtonText: "Create Account",
            pageisDoneLoading:false,
            slideAnimationDone:false,
            registrationVisible:true,
            userFormSubmitActionLoading:false,
            registrationMessageVisible:false,
            registrationMessage: "",
        };
        this.handleChange = this.handleChange.bind(this);
        this.registerNewAccount = this.registerNewAccount.bind(this);
        this.registerNewAccountAction = this.registerNewAccountAction.bind(this);
    }
    registerNewAccountAction() {
        this.setState({
            userFormSubmitAction: true,
            slideAnimationDone:false,
            userFormSubmitActionButtonText: "Please Wait..."
        })
    }

    registerNewAccount() {
        let postData = {
            firstName: this.state.firstName,
            lastName: this.state.lastName,
            email: this.state.email,
            password: this.state.password,
            passwordR: this.state.passwordR,
            referral: this.state.referral,
            telephone: this.state.telephone
        };
        setTimeout(() => {
            ajaxWrapperPost(`/api/user/registerNewAccount`,postData).then((data) => {
                if (data.error === false) {
                    this.setState({
                        registrationMessage: "Success !"
                    })
                }
                else if (data.error === true) {
                    this.refs.notification.notify(data.message,'error');
                    this.setState({
                        registrationMessage: data.message
                    })
                }
            });
        }, 3000);

    }

    handleChange({ target }) {
        const name = target.name;
        const value = target.value;
        this.setState({
                [name]: value
            },
            () => { this.validateField(name, value) }

        );
    }

    validateField(fieldName, value) {
        let _emailValid = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/i;
        let _telValid = /^\(?(\d{3})\)?[- ]?(\d{3})[- ]?(\d{4})$/;
        let _inviteUserEmailValid = this.state.userEmailValid;
        let _inviteUserEmailMessage = this.state.userEmailMessage;

        let _userFirstNameValid = this.state.userFirstNameValid;
        let _userFirstNameMessage = this.state.userFirstNameMessage;

        let _userLastNameValid = this.state.userLastNameValid;
        let _userLastNameMessage = this.state.userLastNameMessage;

        let _userPasswordValid = this.state.userPasswordValid;
        let _userPasswordMessage = this.state.userPasswordMessage;

        let _userPasswordRValid = this.state.userPasswordRValid;
        let _userPasswordRMessage = this.state.userPasswordRMessage;

        let _userReferralValid = this.state.userReferralValid;
        let _userReferralMessage = this.state.userReferralMessage;

        let _userTelephoneValid = this.state.userTelephoneValid;
        let _userTelephoneMessage = this.state.userTelephoneMessage;

        switch(fieldName) {
            case 'email':
                if (!_emailValid.test(value)) {
                    _inviteUserEmailValid = false;
                    _inviteUserEmailMessage = "Invalid Email";
                }
                else {
                    _inviteUserEmailValid = true;
                    _inviteUserEmailMessage = "";

                }
                break;
            case 'firstName':
                if (value.length < 2) {
                    _userFirstNameValid = false;
                    _userFirstNameMessage = "First Name must be 2 characters or greater in length";
                }
                else {
                    _userFirstNameValid = true;
                    _userFirstNameMessage = "";
                }
                break;
            case 'lastName':
                if (value.length < 2) {
                    _userLastNameValid = false;
                    _userLastNameMessage = "Last Name must be 2 characters or greater in length";
                }
                else {
                    _userLastNameValid = true;
                    _userLastNameMessage = "";
                }
                break;
            case 'password':
                if (value.length < 8) {
                    _userPasswordValid = false;
                    _userPasswordRValid = false;
                    _userPasswordMessage = "Password must be 8 characters or greater !";
                }
                else if ((value.search(/[a-z]/i) < 0) || (value.search(/[0-9]/) < 0) || (value.search(/[A-Z]/i) < 0)) {
                    _userPasswordValid = false;
                    _userPasswordRValid = false;
                    _userPasswordMessage = "Password must contain at least one number, one uppercase character and one lowercase character!";
                }
                else {
                    _userPasswordValid = true;
                    _userPasswordMessage = "";
                    _userPasswordRValid = false;

                }
                break;
            case 'passwordR':
                if (value !== this.state.password) {
                    _userPasswordRValid = false;
                    _userPasswordRMessage = "Passwords do not match.";
                }
                else {
                    _userPasswordRValid = true;
                    _userPasswordRMessage = "";

                }
                break;
            case 'referral':
                if (value.length < 2) {
                    _userReferralValid = false;
                    _userReferralMessage = "Referral ID must be 2 characters or greater in length";
                }
                else {
                    _userReferralValid = true;
                    _userReferralMessage = "";
                }
                break;
            case 'telephone':
                if (!_telValid.test(value)) {
                    _userTelephoneValid = false;
                    _userTelephoneMessage = "Invalid Telephone Number";
                }
                else {
                    _userTelephoneValid = true;
                    _userTelephoneMessage = "";

                }
                break;
        }
        this.setState({
            userEmailValid:_inviteUserEmailValid,
            userEmailMessage:_inviteUserEmailMessage,
            userFirstNameValid:_userFirstNameValid,
            userFirstNameMessage:_userFirstNameMessage,
            userLastNameValid: _userLastNameValid,
            userLastNameMessage: _userLastNameMessage,
            userPasswordValid: _userPasswordValid,
            userPasswordMessage: _userPasswordMessage,
            userPasswordRValid: _userPasswordRValid,
            userPasswordRMessage: _userPasswordRMessage,
            userReferralValid: _userReferralValid,
            userReferralMessage: _userReferralMessage,
            userTelephoneValid: _userTelephoneValid,
            userTelephoneMessage: _userTelephoneMessage,
            userFormValid: _inviteUserEmailValid &&
            _userFirstNameValid &&
            _userLastNameValid &&
            _userPasswordValid &&
            _userPasswordRValid &&
            _userReferralValid &&
            _userTelephoneValid

        });
    }
    componentDidMount() {
        this.setState(
            {
                pageisDoneLoading:true
            });
    }
    goToNewPage(path) {
        this.setState({slideAnimationDone:false},() => {
            setTimeout(() => {
                this.setState({pageisDoneLoading:false},() => {
                    setTimeout(() => {
                        this.props.history.replace(path);
                    },600)
                });
            }, 500);

        });
    }

    render() {
        return (
            <div className="app flex-row align-items-center" id="introBackground">
                <NotificationHOC ref="notification"/>
                <AnimatedDivSlide
                    pose={this.state.pageisDoneLoading ? 'visible' : 'hidden'}
                    className="login-container d-flex flex-column"
                    onPoseComplete={() => this.setState({slideAnimationDone: true})}
                >
                    <div className="flex-column px-lg-5 p-5 align-items-center" >
                        <AnimatedDivOpacity
                            pose={this.state.slideAnimationDone ? 'visibleOpacity' : 'hiddenOpacity'}
                            onPoseComplete={() => this.state.userFormSubmitAction && this.setState({registrationVisible:false,userFormSubmitActionLoading:true})}
                        >
                            { this.state.registrationVisible && <div className="col-12">
                                <Row>
                                    <div className="col-12">
                                        <CardBody className="card-body">
                                            <Row>
                                                <div className="col-12">
                                                    <h1>Register</h1>
                                                    <p className="text-muted">Create your account</p>
                                                </div>
                                            </Row>
                                            <InputGroup className="mb-3">
                                                <div className="input-group-prepend"><span className={`input-group-text`}><i className="icon-user"></i></span>
                                                </div>
                                                <Input type="text" placeholder="First Name" id="firstName" name="firstName" className={this.state.firstName.length === 0 ? "" : this.state.userFirstNameValid ? "is-valid" : "is-invalid"} value={ this.state.firstName } onChange={ this.handleChange } required readOnly={this.state.userFormSubmitAction}/>
                                                {this.state.userFirstNameMessage.length <= 0 ? "" :
                                                    <div className="invalid-feedback" id="passwordError" >{this.state.userFirstNameMessage}</div>
                                                }
                                            </InputGroup>
                                            <InputGroup className="mb-3">
                                                <div className="input-group-prepend"><span className={`input-group-text ${this.state.userLastNameValid ? "is-valid" : "is-invalid"}`}><i className="icon-user"></i></span>
                                                </div>
                                                <Input type="text" placeholder="Last Name" id="lastName" name="lastName" className={this.state.lastName.length === 0 ? "" : this.state.userLastNameValid ? "is-valid" : "is-invalid"} value={ this.state.lastName } onChange={ this.handleChange } required readOnly={this.state.userFormSubmitAction}/>
                                                {this.state.userLastNameMessage.length <= 0 ? "" :
                                                    <div className="invalid-feedback" id="passwordError" >{this.state.userLastNameMessage}</div>
                                                }
                                            </InputGroup>
                                            <InputGroup className="mb-3">
                                                <div className="input-group-prepend"><span className="input-group-text">@</span></div>
                                                <Input type="text" placeholder="Email" id="email" name="email" className={this.state.email.length === 0 ? "" : this.state.userEmailValid ? "is-valid" : "is-invalid"} value={ this.state.email } onChange={ this.handleChange } required readOnly={this.state.userFormSubmitAction}/>
                                                {this.state.userEmailMessage.length <= 0 ? "" :
                                                    <div className="invalid-feedback" id="passwordError" >{this.state.userEmailMessage}</div>
                                                }
                                            </InputGroup>
                                            <InputGroup className="mb-1">
                                                <div className="input-group-prepend"><span className="input-group-text"><i className="fa fa-phone"></i></span></div>
                                                <Input type="text" placeholder="Phone Number" id="telephone" name="telephone" className={this.state.telephone.length === 0 ? "" : this.state.userTelephoneValid ? "is-valid" : "is-invalid"} value={ this.state.telephone } onChange={ this.handleChange } required readOnly={this.state.userFormSubmitAction}/>
                                                {this.state.userTelephoneMessage.length <= 0 ? "" :
                                                    <div className="invalid-feedback" id="passwordError" >{this.state.userTelephoneMessage}</div>
                                                }
                                            </InputGroup>
                                            <FormText color="muted" className="mb-3">
                                                ex. (999) 999-9999
                                            </FormText>
                                            <InputGroup className="mb-3">
                                                <div className="input-group-prepend"><span className="input-group-text"><i className="icon-lock"></i></span></div>
                                                <Input type="password" placeholder="Password" id="password" name="password" className={this.state.password.length === 0 ? "" : this.state.userPasswordValid ? "is-valid" : "is-invalid"} value={ this.state.password } onChange={ this.handleChange } required readOnly={this.state.userFormSubmitAction}/>
                                                {this.state.userPasswordMessage.length <= 0 ? "" :
                                                    <div className="invalid-feedback" id="passwordError" >{this.state.userPasswordMessage}</div>
                                                }
                                            </InputGroup>
                                            <InputGroup className="mb-4">
                                                <div className="input-group-prepend"><span className="input-group-text"><i className="icon-lock"></i></span></div>
                                                <Input type="password" placeholder="Repeat password" id="passwordR" name="passwordR" className={this.state.passwordR.length === 0 ? "" : this.state.userPasswordRValid ? "is-valid" : "is-invalid"} value={ this.state.passwordR } onChange={ this.handleChange } required readOnly={this.state.userFormSubmitAction}/>
                                                {this.state.userPasswordRMessage.length <= 0 ? "" :
                                                    <div className="invalid-feedback" id="passwordError" >{this.state.userPasswordRMessage}</div>
                                                }
                                            </InputGroup>
                                            <hr className="mb-4"/>
                                            <InputGroup className="mb-1">
                                                <div className="input-group-prepend"><span className="input-group-text"><i className="fa fa-user-secret"></i></span></div>
                                                <Input type="password" placeholder="Referral ID" id="referral" name="referral" className={this.state.referral.length === 0 ? "" : this.state.userReferralValid ? "is-valid" : "is-invalid"} value={ this.state.referral } onChange={ this.handleChange } required readOnly={this.state.userFormSubmitAction}/>
                                                {this.state.userReferralMessage.length <= 0 ? "" :
                                                    <div className="invalid-feedback" id="passwordError" >{this.state.userReferralMessage}</div>
                                                }
                                            </InputGroup>
                                            <FormText color="muted" className="mb-3">
                                                Enter referral ID provided.
                                            </FormText>
                                            <Row>
                                                <Col sm="12" className="mb-4">
                                                    <Button color="primary" className="px-4 btn btn-block" block disabled={!this.state.userFormValid && !this.state.userFormSubmitAction} onClick={() => {this.registerNewAccount();this.registerNewAccountAction();}}>{this.state.userFormSubmitActionButtonText}</Button>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col sm="12">
                                                    <hr className="mb-4"/>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col sm="12">
                                                    <Col xs="12" >
                                                        Do you currently have an account? <button className="btn btn-link text-black-50" onClick={() => this.goToNewPage('/login')}>Go to Login</button><br/>
                                                    </Col>
                                                </Col>
                                            </Row>
                                        </CardBody>
                                    </div>
                                </Row>
                            </div> }
                        </AnimatedDivOpacity>
                        <RegistrationInProgress
                            pose={this.state.userFormSubmitActionLoading ? 'visibleOpacityuserFormSubmitAction' : 'hiddenOpacityuserFormSubmitAction'}
                            onPoseComplete={() => {
                                if (this.state.userFormSubmitAction) this.setState({registrationVisible:false});
                                setTimeout(() => {
                                    this.setState({
                                        userFormSubmitActionLoading:false,
                                        registrationMessageVisible:true
                                    });
                                },3000);
                            }}
                        >
                            <div className="col-12">
                                <div className="sk-circle align-items-center">
                                    <div className="sk-circle1 sk-child"></div>
                                    <div className="sk-circle2 sk-child"></div>
                                    <div className="sk-circle3 sk-child"></div>
                                    <div className="sk-circle4 sk-child"></div>
                                    <div className="sk-circle5 sk-child"></div>
                                    <div className="sk-circle6 sk-child"></div>
                                    <div className="sk-circle7 sk-child"></div>
                                    <div className="sk-circle8 sk-child"></div>
                                    <div className="sk-circle9 sk-child"></div>
                                    <div className="sk-circle10 sk-child"></div>
                                    <div className="sk-circle11 sk-child"></div>
                                    <div className="sk-circle12 sk-child"></div>
                                </div>
                            </div>
                        </RegistrationInProgress>

                        <RegistrationMessage pose={this.state.registrationMessageVisible ? 'visibleRegistrationMessage' : 'hiddenRegistrationMessage'}>
                            <Row className="justify-content-center">
                                <Col md="12">
                                    <h1>Account Successfully Registered</h1>
                                    <p className="text-muted">Welcome {this.state.firstName} {this.state.lastName}</p>
                                    <hr className="mb-4"/>
                                    <a href="#/login">
                                        <Button color="link" className="px-4 btn btn-block">Continue and login with your credentials</Button>
                                    </a>
                                </Col>
                            </Row>
                        </RegistrationMessage>

                    </div>
                </AnimatedDivSlide>
            </div>
        );
    }
}

export default Register;



// WEBPACK FOOTER //
// ./src/views/Pages/Register/Register.js